function trySS<T>(fn: () => T, fallback: T): T {
    try {
        return fn();
    } catch {
        return fallback;
    }
}

export const safeSessionStorage = {
    getItem: (key: string): string | null => trySS(() => sessionStorage.getItem(key), null),
    setItem: (key: string, value: string): void => trySS(() => { sessionStorage.setItem(key, value); }, undefined),
    removeItem: (key: string): void => trySS(() => { sessionStorage.removeItem(key); }, undefined),
};

export const safeLocalStorage = {
    getItem: (key: string): string | null => trySS(() => localStorage.getItem(key), null),
    setItem: (key: string, value: string): void => trySS(() => { localStorage.setItem(key, value); }, undefined),
    removeItem: (key: string): void => trySS(() => { localStorage.removeItem(key); }, undefined),
};
